// @flow
import { useSearchParams } from 'react-router-dom';

const useSetDatesParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamsObject = Object.fromEntries([...searchParams]);

  return (params: any) =>
    setSearchParams(
      {
        ...searchParamsObject,
        ...params
      },
      { replace: true }
    );
};

export default useSetDatesParams;
